import { render, staticRenderFns } from "./remill.vue?vue&type=template&id=787d27f6&"
import script from "./remill.vue?vue&type=script&lang=js&"
export * from "./remill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports